// Mock data for Powerlab Works

export const vehicleBrands = [
  'Alfa Romeo', 'Aston Martin', 'Audi', 'Bentley', 'BMW', 'Bugatti',
  'Cadillac', 'Chevrolet', 'Chrysler', 'Ferrari', 'Ford', 'Honda',
  'Hyundai', 'Jaguar', 'Jeep', 'Lamborghini', 'Land Rover', 'Lexus',
  'Maserati', 'Mazda', 'McLaren', 'Mercedes', 'Mini', 'Mitsubishi',
  'Nissan', 'Porsche', 'Rolls Royce', 'Tesla', 'Toyota', 'Volkswagen', 'Volvo'
];

export const services = [
  {
    id: 1,
    title: 'Chip Tuning',
    description: 'Unlock the true potential of your vehicle. Our expert chip tuning services optimize engine performance, delivering more power, better fuel efficiency, and enhanced driving dynamics.',
    image: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800&q=80',
    link: '/chiptuning'
  },
  {
    id: 2,
    title: 'ECU Remapping',
    description: 'Advanced ECU remapping for all vehicle types. We use state-of-the-art equipment to safely increase horsepower and torque while maintaining reliability.',
    image: 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=800&q=80',
    link: '/ecu-remapping'
  },
  {
    id: 3,
    title: 'Performance Testing',
    description: 'Precision testing with our Dynoflow SF-849 Chassis Dyno. We verify every modification for power, fuel efficiency, boost pressure, and emissions.',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&q=80',
    link: '/testing'
  }
];

export const stats = [
  { number: '14+', label: 'Years Experience' },
  { number: '40+', label: 'International Dealers' },
  { number: '20+', label: 'Countries' },
  { number: '300,000+', label: 'Vehicle Files Tuned' }
];

export const dealers = [
  { name: 'Powerlab Works HQ Estonia', country: 'Estonia', city: 'Tallinn' },
  { name: 'Powerlab Works HQ Turkey', country: 'Turkey', city: 'Izmir' },
  { name: 'Aktiv CRTP', country: 'Turkey', city: 'Ankara' },
  { name: 'Auto Tech', country: 'England', city: 'London' },
  { name: 'BMW F.G.I. Owners Club HK', country: 'Hong Kong', city: 'Hong Kong' },
  { name: 'Canton-Tech', country: 'France', city: 'Paris' },
  { name: 'CDany Service', country: 'Romania', city: 'Bucharest' },
  { name: 'Çeşmeliler BCS', country: 'Turkey', city: 'Denizli' },
  { name: 'Dino Garage', country: 'Turkey', city: 'Izmir' },
  { name: 'Ecurevival', country: 'Greece', city: 'Athens' },
  { name: 'Electronic-Lab', country: 'Croatia', city: 'Zagreb' },
  { name: 'Funware Chiptuning', country: 'Poland', city: 'Warsaw' },
  { name: 'Grv Garage', country: 'Romania', city: 'Cluj-Napoca' },
  { name: 'Kintec', country: 'Bosnia', city: 'Sarajevo' },
  { name: 'Megaservice', country: 'Finland', city: 'Helsinki' },
  { name: 'My Cars SPRL', country: 'Belgium', city: 'Brussels' },
  { name: 'NavSolutions', country: 'Bosnia', city: 'Mostar' },
  { name: 'Powerlab Sweden North', country: 'Sweden', city: 'North Region' },
  { name: 'Powerlab Official Dealer Sweden', country: 'Sweden', city: 'Katrineholm' },
  { name: 'Powerlab Sweden', country: 'Sweden', city: 'Stockholm' },
  { name: 'Pro Car Service', country: 'Cyprus', city: 'Nicosia' },
  { name: 'TheTuner', country: 'Thailand', city: 'Bangkok' },
  { name: 'Twemotorsport', country: 'Portugal', city: 'Lisbon' }
];

export const testimonials = [
  {
    id: 1,
    name: 'Marcus R.',
    vehicle: 'BMW M3 Competition',
    rating: 5,
    text: 'Incredible results! My M3 gained 80hp and the delivery is so smooth. The team at Powerlab knows exactly what they\'re doing. Highly recommended!'
  },
  {
    id: 2,
    name: 'Sarah L.',
    vehicle: 'Audi RS6 Avant',
    rating: 5,
    text: 'Professional service from start to finish. The performance increase is amazing and the car feels more responsive than ever. Worth every penny!'
  },
  {
    id: 3,
    name: 'James K.',
    vehicle: 'Porsche 911 Turbo S',
    rating: 5,
    text: 'Best tuning shop in Europe! The attention to detail and the dyno testing gave me complete confidence in the work. Outstanding results.'
  }
];

export const benefits = [
  {
    icon: 'Zap',
    title: 'More Power',
    description: 'Increase horsepower and torque by up to 30%'
  },
  {
    icon: 'Gauge',
    title: 'Better Performance',
    description: 'Enhanced throttle response and acceleration'
  },
  {
    icon: 'Fuel',
    title: 'Fuel Efficiency',
    description: 'Optimized fuel consumption for better economy'
  },
  {
    icon: 'Shield',
    title: 'Safe & Reliable',
    description: 'Tested and proven reliability with warranty'
  }
];

export const faqs = [
  {
    question: 'What is chip tuning?',
    answer: 'Chip tuning is the process of optimizing your vehicle\'s engine control unit (ECU) to improve performance. We modify the engine parameters to unlock additional power, torque, and efficiency while maintaining reliability and safety.'
  },
  {
    question: 'Is chip tuning safe for my vehicle?',
    answer: 'Yes, when done professionally. At Powerlab Works, we use advanced dyno testing equipment and proven tuning files. All modifications stay within safe operating parameters to ensure long-term reliability.'
  },
  {
    question: 'Will tuning void my warranty?',
    answer: 'Chip tuning may affect your manufacturer warranty. However, we offer our own warranty on our tuning work. We recommend discussing this with your dealer or contacting us for specific advice on your vehicle.'
  },
  {
    question: 'How long does the tuning process take?',
    answer: 'Most chip tuning services take 2-4 hours, including dyno testing and quality checks. More complex modifications or performance packages may require additional time.'
  },
  {
    question: 'Can the tuning be reversed?',
    answer: 'Yes, all our chip tuning modifications can be fully reversed. We keep a backup of your original ECU settings and can restore them at any time if needed.'
  }
];